export interface PullToRefreshGesture {
  startX: number
  startY: number
  currentX: number
  currentY: number
}

export function isPullToRefreshGesture(gesture: PullToRefreshGesture, threshold: number): boolean {
  const horizontalDistance = Math.abs(gesture.currentX - gesture.startX)
  const verticalDistance = gesture.currentY - gesture.startY
  return verticalDistance >= threshold && verticalDistance > horizontalDistance * 1.25
}
